import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-travel-bill-log',
  templateUrl: './travel-bill-log.component.html',
  styleUrls: ['./travel-bill-log.component.css']
})
export class TravelBillLogComponent implements OnInit {
    travelBillLogKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.travelBillLogKeyno = this.stateService.getStateParams()['travelbillog_keyno'];
    }

    private async loadMenu() {
        if (!!this.travelBillLogKeyno) {
            this.menu = (await this.datatask.Post(1722, { travelbillog_keyno: this.travelBillLogKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    reg_datetime: string;
    reg_by_portal_user_name: string;
    note: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelBillLog', {
//        templateUrl: 'views/components/views/travelBillLog/travelBillLog.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'travelBillLogService', function ($stateParams, travelBillLogService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelBillLogKeyno = $stateParams.travelbillog_keyno;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS

//            async function loadMenu() {
//                vm.model.menu = (await travelBillLogService.getMenu({ travelbillog_keyno: travelBillLogKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
